import React from "react";

const SearchIcon = () => {
  return (
    <svg
      className="search-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.1 19.6"
    >
      <circle cx="6.5" cy="6.5" r="5" />
      <path d="M9.4 11.2l5.2 6.9" />
    </svg>
  );
};

export default SearchIcon;
